import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, Tag, Space } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { GlobalOutlined } from "@ant-design/icons";

import { ICountry } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const CountryEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<ICountry>();

  return (
    <Edit
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "edit country",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Country Information"
            subtitle="Country details and ISO codes"
            icon={<GlobalOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={3}>
              <Form.Item
                label="Country Name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="ISO Country Code"
                name="isoCode"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="ISO3 Country Code"
                name="iso3Code"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
        </Space>
      </Form>
    </Edit>
  );
};
